<template>
    <el-container>
        <el-main class="AAAAAAA">
            <el-tabs v-model="activeName" type="border-card">
                <el-tab-pane label="表格/按钮/输入框" name="first">
                    <td-checkbox-group></td-checkbox-group>
                    <first></first>
                </el-tab-pane>
                <el-tab-pane label="选择器/复选框/计数器/switch/穿梭框/上传" name="second">
                    <scend></scend>
                </el-tab-pane>
                <el-tab-pane label="轮播" name="third">
                    <third></third>
                </el-tab-pane>
                <el-tab-pane label="树形表格" name="fourth">
                    <fourth></fourth>
                </el-tab-pane>
                <el-tab-pane label="时间选择器" name="fifth">
                    <fifth></fifth>
                </el-tab-pane>
            </el-tabs>
        </el-main>
    </el-container>
</template>
<script>
import first from './components/first.vue';
import scend from './components/scend.vue';
import third from './components/third.vue';
import fourth from './components/fourth.vue';
import fifth from './components/fifth.vue';

export default {
    components: {
        first: first,
        scend: scend,
        third: third,
        fourth: fourth,
        fifth: fifth
    },
    /* 定义变量 */
    data() {
        return {
            activeName: 'first',
            treeHeight: window.innerHeight - 160,
            areaCodes: ['BH-0001-0001'],
            schoolCodes: ['BH-0001-SF']
        };
    },
    beforeDestroy() {
        // first = null;
        // scend = null;
        // third = null;
        // fourth = null;
        // fifth = null;
        this.components = null;
        this.activeName = null;
        this.treeHeight = null;
        this.areaCodes = null;
        this.schoolCodes = null;
    }
};
</script>
<style>
.AAAAAAA .el-tabs--border-card > .el-tabs__content {
    padding-bottom: 0 !important;
}
</style>
